import React from "react";
import "./styles.css";
import {
    EMPTY_STRING,
    TOTAL_DEFAULT_STEPS,
    TOTAL_FREEHAND_STEPS,
} from "../../../constants";
import PropTypes from "prop-types";
import AHButton from "../../__shared__/StyleGuide/AHButton";

class PatientPlansSubListItem extends React.PureComponent {
    render() {
        let inProgColor = this.props.inProgress
            ? "text-primary-500"
            : "text-neutral-950";
        let totalPlanSteps = this.props.isFreehandPlan
            ? TOTAL_FREEHAND_STEPS
            : TOTAL_DEFAULT_STEPS;
        let btnDownloadId = `patient-button-download-${this.props.keyId}`;

        let pdfOnly = false;
        let downloadDisplay = { display: "auto" };
        let btnText = "Download Plan";

        if (this.props.hasCEM && this.props.inProgress) {
            pdfOnly = true;
            btnText = "Patient Report";
        } else if (this.props.hasCEM && !this.props.inProgress) {
            pdfOnly = false;
        } else if (this.props.inProgress) {
            downloadDisplay = { display: "none" };
        }

        return (
            <div
                className="plan-sub-list-item flex items-center justify-between"
                style={this.props.style}
            >
                <div className="plan-id-box flex items-center">
                    <p className={`text-lg ${inProgColor}`}>
                        Step:&nbsp;{this.props.finalStep + 1}/
                        {totalPlanSteps.toString()}
                    </p>
                </div>
                <div className={"patient-history-button-wrapper"}>
                    {this.props.button}

                    <AHButton
                        id={btnDownloadId}
                        className={"right left-margin"}
                        size={"large"}
                        style={downloadDisplay}
                        onClick={() =>
                            this.props.clickCallback(
                                this.props.patientUuid,
                                this.props.planUuid,
                                pdfOnly
                            )
                        }
                        text={btnText}
                    />
                </div>
            </div>
        );
    }
}

PatientPlansSubListItem.propTypes = {
    keyId: PropTypes.number,
    date: PropTypes.string,
    patientUuid: PropTypes.string,
    planUuid: PropTypes.string,
    clickCallback: PropTypes.func,
    inProgress: PropTypes.bool,
    style: PropTypes.object,
    button: PropTypes.any,
    finalStep: PropTypes.number,
    isFreehandPlan: PropTypes.bool,
    hasCEM: PropTypes.bool,
};

PatientPlansSubListItem.defaultProps = {
    date: EMPTY_STRING,
    patientUuid: EMPTY_STRING,
    planUuid: EMPTY_STRING,
    clickCallback: null,
    inProgress: false,
    finalStep: 0,
};

export default PatientPlansSubListItem;
